import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "./App.css";
import { Container } from "./components/index";
import { Header, Footer } from "./sections/index";
import { Home } from "./pages/index";

const App = () => {
  return (
    // don't get div tag in the root
    <>
      <Router basename={"/cyborg-gaming"}>
        <Header />
        <Container>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </Container>
        <Footer />
      </Router>
    </>
  );
};

export default App;
